import React from "react";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import SortableItem from "./SortableItem";

export default function Container(props) {
  const { id, items, active, activeId } = props;

  const { setNodeRef } = useDroppable({
    id
  });

  const settingContainerStyle = css`
    margin: 0;
  `;



  return (
    <SortableContext
      id={id}
      items={items}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef} css={settingContainerStyle}>
        {items?.length > 0 ? (
          items.map((id) => (
            <SortableItem key={id} id={id} active={active} activeId={activeId} />
          ))
        ) : (
          " "
        )}
      </div>
    </SortableContext>
  );
}
